import { Button } from "../components/ui/button";
import { logVersion } from "../lib/utils";
export default Button;
logVersion();